


export class MembroVO {

    id: string;

    nome: string;

    cognome: string;

    email: string[];

    pec: string;


    codiceFiscale: string;

    presidenteCollegio: boolean;

}
